import Fuse from 'fuse.js';
import { USER_UNAUTH_COLLAB, NON_FILTER } from '../common/constant';
import SENTRY from '../custom/sentry.js';

custom.photoDownloads = (() => {
  // Variables
  let downloadsType = document.getElementById('downloadsType');
  const productsPerPage = 24;
  let initializedPaginationClick = 2;
  const searchOptions = {
    shouldSort: true,
    threshold: 0.2,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 3,
    keys: [
      {
        name: 'title',
        weight: 0.7,
      },
      {
        name: 'handle',
        weight: 0.2,
      },
      {
        name: 'image',
        weight: 0.2,
      },
    ],
  };
  const bucket =
    window.LoloiConfig.erp_source == 'NETSUITE'
      ? '300asset'
      : 'assets.loloirugs.com';

  const pagePDP = $('.js-photo-download-pdp').length > 0;

  const pdpSVG = `<span class="flex"><svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.7349 6.78164L8.89462 10.0454V2.00009H7.10547V10.0455L3.26512 6.78164L2 7.85684L8.00001 12.9561L14 7.85684L12.7349 6.78164ZM13.3677 14.4793H2.63281V15.9999H13.3677V14.4793Z" fill="currentColor"/>
</svg></span>`;

  const pdpSingleSVG = `<span><svg width="8px" height="10px" viewBox="0 0 7 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g transform="translate(-137.000000, -5.000000)">
        <g>
            <g transform="translate(137.000000, 5.000000)">
                <g>
                    <rect fill="#ffffff" x="0.5" y="8" width="6" height="1"></rect>
                    <g transform="translate(3.500000, 3.500000) rotate(-90.000000) translate(-3.500000, -3.500000) ">
                        <polyline stroke="#ffffff" transform="translate(2.000000, 3.500000) scale(-1, 1) rotate(-90.000000) translate(-2.000000, -3.500000) " points="5 2 2 5 -1 2"></polyline>
                        <rect fill="#ffffff" x="1" y="3" width="6" height="1"></rect>
                    </g>
                </g>
            </g>
        </g>
    </g>
</g>
</svg></span>`;

  const singleImageAnimation = `<span>
<svg width="10px" height="10px" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" transform="scale(2)"
  viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
    <path fill="#ffffff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
      <animateTransform
         attributeName="transform"
         attributeType="XML"
         type="rotate"
         dur="1s"
         from="0 50 50"
         to="360 50 50"
         repeatCount="indefinite" />
  </path>
</svg></span>`;

  const imageAnimationPDP = `<span class="flex">
<svg width="18px" height="18px" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" transform="scale(2)"
viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
  <path fill="currentColor" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
    <animateTransform
       attributeName="transform"
       attributeType="XML"
       type="rotate"
       dur="1s"
       from="0 50 50"
       to="360 50 50"
       repeatCount="indefinite" />
</path>
</svg></span>`;

  // String helper
  function titleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  // Handler to control visible secondary selectors
  function typeSelectionHandler(e) {
    return (window.location =
      '/account?view=photo-downloads&type=' + e.target.value);
  }

  // Helper to get query param from URL
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function clearResults() {
    $('.js-hidden-no-products').addClass('hidden');
    let downloadsResults = document.getElementById('downloadsResults');
    downloadsResults.innerHTML = '';
    let downloadsPagination = document.getElementById('downloadsPagination');
    downloadsPagination.innerHTML = '';
    $('.error-message').html('');
  }

  // Fetch all Collections
  function fetchAllCollections() {
    return $.ajax({
      type: 'GET',
      cache: true,
      url: '/collections?view=json',
      error: (err) => {
        custom.utils.sendCustomSentryError(
          `Fetch all collections failed`,
          {
            extra: {error: err, message: 'Get All Collections JSON view Failed'},
            tags: {module: 'Photo Downloads', category: SENTRY.CATEGORIES.ACCOUNT},
          },
        );
      }
    });
  }

  // Fetch all Products inside collection
  function fetchCollectionProducts(collection = '') {
    return $.ajax({
      type: 'GET',
      url: `/collections/${collection}?view=json`,
      error: (err) => {
        custom.utils.sendCustomSentryError(
          `Fetch collection products failed`,
          {
            extra: {error: err, message: 'Get Collections JSON view Failed'},
            tags: {module: 'Photo Downloads', category: SENTRY.CATEGORIES.ACCOUNT},
          },
        );
      }
    });
  }

  // Helper to parse Products to Images object
  function parseToImagesObject(data, featured = false) {
    let imageObjects = [];
    const products = JSON.parse(data);
    if (featured) {
      products.hits.forEach((product, index) => {
        if (
          product.collaboration &&
          USER_UNAUTH_COLLAB &&
          USER_UNAUTH_COLLAB.includes(product.collaboration)
        )
          return;
        if (product.type) {
          if (product.type.indexOf('COLOR BLANKET') > -1) return;
          if (product.type.indexOf('COLOR BLOCK') > -1) return;
        }
        imageObjects.push({
          title: product.title,
          handle: product.handle,
          image: product.featured_image,
          sku: product.sku.substr(0, product.sku.length - 4),
        });
      });
    } else {
      products.hits.forEach((product, index) => {
        if (
          product.collaboration &&
          USER_UNAUTH_COLLAB &&
          USER_UNAUTH_COLLAB.includes(product.collaboration)
        )
          return;
        //filter out OAK products
        if (NON_FILTER.indexOf(product.collaboration) >= 0) return;
        if (product.type) {
          if (product.type.indexOf('COLOR BLANKET') > -1) return;
          if (product.type.indexOf('COLOR BLOCK') > -1) return;
        }
        product.images.forEach((image, index) => {
          imageObjects.push({
            title: product.title,
            handle: product.handle,
            image: image.src,
            alt: image.alt,
            s3ImageName: getPhotoName(image.src),
          });
        });
      });
    }

    return imageObjects;
  }

  function switchPage(event = null, images = {}) {
    // window.scroll({
    //   top: $('.js-photo-download').offset().top - $('.js-navigation').outerHeight(),
    //   left: 0,
    //   behavior: 'smooth'
    // });
    renderImages(images, parseInt($(event.target).data('page-no')));
  }

  function scrollImagesShow() {
    var imageContainer = document.querySelector('#downloadsResults');
    const offset = document.documentElement.clientHeight;
    const distance =
      $(imageContainer).offset().top +
      imageContainer.scrollHeight -
      document.documentElement.clientHeight +
      document.body.getBoundingClientRect().top;
    if (distance - offset < 0) {
      paginationClick();
    }
  }

  function paginationClick() {
    var paginationElements = document.querySelectorAll('[data-page-no]');
    if (initializedPaginationClick < paginationElements.length) {
      paginationElements[initializedPaginationClick].click();
      initializedPaginationClick++;
    } else {
      window.removeEventListener('scroll', scrollImagesShow);
    }
  }

  // Pagination
  function paginationHandler(images = {}) {
    const total = Math.ceil(images.length / productsPerPage);
    let pagination = document.getElementById('downloadsPagination');
    pagination.innerHTML = '';

    // Render Pagination
    for (var i = 1; i <= total; i++) {
      pagination.insertAdjacentHTML(
        'beforeend',
        `<span class="pagination js-downloads-pagination" data-page-no="${i}">${i}</span>`,
      );
    }

    $('.js-downloads-pagination').on('click', (event) => {
      switchPage(event, images);
    });
  }

  // Render
  function renderImages(images = {}, page = 1) {
    --page; // start at 0 if on 1st page
    let prevIndex = page * productsPerPage;
    let nextIndex = productsPerPage * (page + 1);
    let downloadsResults = document.getElementById('downloadsResults');
    // clearResults();

    images.slice(prevIndex, nextIndex).forEach((image, index) => {
      image.selected = $('#checkall').prop('checked');
      downloadsResults.insertAdjacentHTML(
        'beforeend',
        window.productCardDownloadTemplate.render(image),
      );
    });

    if (images.length > productsPerPage) paginationHandler(images);
    custom.typeDesignId.init();
    custom.lazyImages.init();
  }

  // Search
  function searchHandler(images = null) {
    const searchInstance = new Fuse(images, searchOptions);
    const $searchField = $('#downloadsSearchField');
    $searchField.focus();
    $searchField.on('input', (event) => {
      clearResults();
      if (event.target.value.length < 3) return;
      const result = searchInstance.search(event.target.value);
      if (result.length > 0) {
        $('.js-hidden-no-products').removeClass('hidden');
        renderImages(result);
      } else {
        $('#downloadsResults').html(
          '<p class="ml-6">Sorry, no matches. Please try again.</p>',
        );
        $('.js-hidden-no-products').addClass('hidden');
      }
    });
  }

  // PRODUCT initializer
  function initProducts(type) {
    //for pillows, wall art we force users to search
    $('.js-download-search').removeClass('hidden');
    $('#downloadsSelect').addClass('hidden');
    fetchCollectionProducts(type).done((data) => {
      const productImages = parseToImagesObject(data);
      //for pillows, wall art we force users to search
      searchHandler(productImages);
    });
  }

  // COLLECTION initializer
  function initCollections(type) {
    $('.js-hidden-no-products').addClass('hidden');
    const downloadsSelect = document.getElementById('downloadsSelect');
    downloadsSelect.addEventListener('change', selectedCollection);
    fetchAllCollections().done((data) => {
      const collections = JSON.parse(data);

      // "USER_UNAUTH_COLLAB" is brands user is NOT allowed to see/purchase
      collections.hits.forEach((hit, index) => {
        if (
          hit.collaboration &&
          USER_UNAUTH_COLLAB &&
          USER_UNAUTH_COLLAB.includes(hit.collaboration)
        )
          return;
        if (hit.product_type == type) {
          downloadsSelect.insertAdjacentHTML(
            'beforeend',
            `<option value="${hit.handle}">${titleCase(hit.title)}</option>`,
          );
        }
      });
      //Remove Loading message
      $('#downloadsSelect .js-initial-option').text('Select Collection');
    });
  }

  function selectedCollection(e) {
    const collection = e.target.value;
    const displayFeatured = e.target.dataset.featured == 'true' ? true : false;
    clearResults();
    fetchCollectionProducts(collection).done((data) => {
      $('.js-hidden-no-products').removeClass('hidden');
      const collectionProductImages = parseToImagesObject(
        data,
        displayFeatured,
      );
      initClickAllDataset(collectionProductImages);
      const filteredCollectionImages = collectionProductImages.filter(
        (image) => {
          let shouldReturn = true;
          if (displayFeatured) {
            if (image.title.indexOf('COLOR BLANKET') > -1) return false;
            if (image.title.indexOf('COLOR BLOCK') > -1) return false;
          }
          return shouldReturn;
        },
      );
      renderImages(filteredCollectionImages);
      initializedPaginationClick = 1;
      window.addEventListener('scroll', scrollImagesShow);
    });
  }
  function initClickAllDataset(data) {
    $('#hiddenS3Information').html('');
    for (var i = 0; i < data.length; i++) {
      const targetSku = data[i].sku ? ` data-hangtag-sku="${data[i].sku}"` : '';
      const targetS3 = data[i].s3ImageName
        ? ` data-s3-image-name="${data[i].s3ImageName}"`
        : '';
      $('#hiddenS3Information').append(
        `<span class="js-s3-photo-data" ${targetSku} ${targetS3}></span>`,
      );
    }
  }

  function canSubmit() {
    // Control Download Button
    if ($('.card-block__item.checked').length) {
      $('.js-download-button').prop('disabled', false);
    } else {
      $('.js-download-button').prop('disabled', true);
    }

    // Control Check All button
    if (
      $('.card-block__item.checked').length === $('.card-block__item').length
    ) {
      $('#checkall').prop('checked', true);
    } else {
      $('#checkall').prop('checked', false);
    }
  }

  function selectNoneHandler() {
    $('.card-block__item').removeClass('checked');
    canSubmit();
  }

  function selectAllHandler() {
    $('.card-block__item').addClass('checked');
    canSubmit();
  }

  function toggleAllHandler(e) {
    const $this = $(this);
    $('.error-message').html('');
    if ($this.prop('checked') === true) {
      selectAllHandler(e);
    } else {
      selectNoneHandler(e);
    }
    canSubmit();
  }

  // selectHandler when a card is checked
  function selectedHandler(e) {
    e.stopPropagation();
    e.preventDefault();
    $('.error-message').html('');
    const $currentTarget = $(e.currentTarget);
    $currentTarget.toggleClass('checked');
    if (!$currentTarget.hasClass('checked'))
      $('#checkall').prop('checked', false);
    canSubmit();
  }

  /*
   * getPhotoName
   *
   * returns Image Name on S3 with parsing image src and alt tag
   *
   * @param {string} imgSrc - product image src string
   * @param {string} imgAlt - product image alt tag string
   */
  function getPhotoName(imgSrc = '') {
    imgSrc = imgSrc
      .substring(imgSrc.lastIndexOf('/') + 1)
      .replace('/products/', '')
      .replace(
        /_[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}/,
        '',
      )
      .replace('_5B', '[')
      .replace('_5D', ']')
      .replace('_300x', '');
    return imgSrc.substr(0, imgSrc.indexOf('?v='));
  }

  /*
   * submitHandler
   *
   * sends an array of image file names to S3
   * returns zip file url
   *
   */
  let $target;
  let targetType;

  function submitHandler(e) {
    $target = $(this);
    e.preventDefault();
    e.stopPropagation();
    let payload = [];
    let onPhotoDownload = !pagePDP ? false : true;
    $('.error-message').html('');
    if (!pagePDP) {
      $('.js-download-button')
        .prop('disabled', true)
        .addClass('js-loading')
        .addClass('js-working')
        .html(
          "Downloading<span class='ellipsis'><span>.</span><span>.</span><span>.</span></span>",
        );
      targetType =
        $('#checkall').prop('checked') && $('.js-s3-photo-data').length
          ? '.js-s3-photo-data'
          : '.card-block__item.checked';
      $(targetType).each(function () {
        const $card = $(this);
        const fileName = $card.data('s3-image-name')
          ? $card.data('s3-image-name')
          : 'hangtags/' + $card.data('hangtag-sku') + '.pdf';
        onPhotoDownload = !!$card.data('s3-image-name');
        payload.push(fileName);
      });
    } else {
      targetType = $target.closest('a').hasClass('image-download-link')
        ? 'single'
        : 'all';
      if (targetType == 'single') {
        //single image download
        $target.addClass('js-loading js-working').html(singleImageAnimation);
        const fileName = $(this)
          .closest('.js-s3-photo-data')
          .data('s3-image-name');
        payload.push(fileName);
      } else {
        //download all images
        $target
          .find('.js-download-button-icon')
          .addClass('js-loading')
          .html(imageAnimationPDP);
        $('#hiddenS3Information .js-s3-photo-data').each(function () {
          const fileName = $(this).data('s3-image-name');
          payload.push(fileName);
        });
      }
    }
    const chunkedPayload = custom.utils.chunkArray(payload, 10);
    let errorsCount = 0;
    let zipCount = 0;

    custom.utils
      .asyncForEach(chunkedPayload, async (chunkArray) => {
        zipCount++;
        if (targetType != 'single')
          updateProgressBar(zipCount, chunkedPayload.length);
        try {
          await $.ajax({
            type: 'POST',
            url: 'https://2u50g16rl6.execute-api.us-east-1.amazonaws.com/dev/photoDownload',
            dataType: 'json',
            crossDomain: true,
            data: JSON.stringify({
              region: 'us-east-1',
              bucket: bucket,
              folder: '',
              zipFileName: onPhotoDownload
                ? `${meta.page.customerId}.zip`
                : `hangtag-${meta.page.customerId}.zip`,
              files: chunkArray,
            }),
            success: (response) => {
              eventTrackingHandler(onPhotoDownload);
              successHandler(response);
            },
            error: (err) => {
              custom.utils.sendCustomSentryError(
                `Photo Download Failed`,
                {
                  extra: {error: err},
                  tags: {module: 'Photo Downloads', category: SENTRY.CATEGORIES.ACCOUNT},
                },
              );
              return err;
            },
          });
        } catch (error) {
          errorsCount += 1;
        }
      })
      .then(
        function () {
          errorsCount > 0 ? errorHandler() : downloadsCompleted($(this));
        },
        function error() {
          errorHandler();
        },
      );
  }

  function errorHandler(err = null) {
    $('.error-message')
      .html(
        'Warning: Some selected files could not be downloaded at this time.',
      )
      .removeClass('hidden');
    custom.utils.sendCustomSentryError(
        `Photo Download Failed`,
        {
          extra: {error: err},
          tags: {module: 'Photo Downloads', category: SENTRY.CATEGORIES.ACCOUNT},
        },
      );
    if (!pagePDP) {
      $('.js-download-button')
        .removeClass('js-loading')
        .removeClass('js-working')
        .html('Download Images');
      canSubmit();
    } else {
      if (targetType != 'single') {
        setTimeout(function () {
          $target
            .find('.js-download-button-icon')
            .removeClass('js-loading')
            .html(pdpSVG)
            .blur();
        }, 1500);
      } else {
        setTimeout(function () {
          $target
            .removeClass('js-loading')
            .removeClass('js-working')
            .html(pdpSingleSVG);
        }, 1500);
      }
    }
    $('#progressContainer').addClass('hidden');
    $('#progressContainer').find('.progressBar').css('width', 0);
  }

  function successHandler(data = null) {
    // this will prompt the user to allow the download from the pop-up blocker
    window.location.assign(data.url);
  }

  /*
   * updateProgressBar
   *
   * Updated the text of the progress display and the progress bar.
   *
   */
  function updateProgressBar(current, length) {
    const width = parseFloat((current / length) * 100).toPrecision(2);
    const $progressContainer = $('#progressContainer');
    $progressContainer.removeClass('hidden');
    $progressContainer.find('.progressBar').css('width', `${width}%`);
    $progressContainer
      .find('.progressText')
      .text(`Creating Zip File ${current} of ${length}.`);
  }

  function eventTrackingHandler(onPhotoDownload = true) {
    let type;
    if (!pagePDP) {
      type = onPhotoDownload
        ? custom.utils.titleCase($('#downloadsType').val())
        : false;
    } else {
      type = custom.utils.titleCase(
        $('#hiddenS3Information').data('product-type'),
      );
    }
    let action;
    if (!pagePDP) {
      action = onPhotoDownload
        ? type !== 'Pillows' && type !== 'Wall-art' && type !== 'Poufs'
          ? `${type} - ${custom.utils.titleCase($('#downloadsSelect').val())}`
          : type
        : custom.utils.titleCase($('#downloadsSelect').val());
    } else {
      action =
        type !== 'Pillows' && type !== 'Wall-art' ? `${type} - ${type}` : type;
    }

    custom.gtmDatalayer.gtmPush({
      eventCategory: 'Account',
      eventAction: action,
      eventLabel: onPhotoDownload ? 'Download Images' : 'Download Hangtags',
    });
  }

  function downloadsCompleted(data = null) {
    $('.error-message').html('');
    if (pagePDP) {
      if (targetType != 'single') {
        $target
          .find('.js-download-button-icon')
          .removeClass('js-loading')
          .html(pdpSVG);
        setTimeout(function () {
          $target.find('.js-download-button-icon').html(pdpSVG).blur();
        }, 1500);
        $('#progressContainer').addClass('hidden');
        $('#progressContainer').find('.progressBar').css('width', 0);
      } else {
        setTimeout(function () {
          $target
            .removeClass('js-loading')
            .removeClass('js-working')
            .html(pdpSingleSVG);
        }, 1500);
      }
    } else {
      $('.js-download-button')
        .removeClass('js-loading')
        .html('Download Complete!');
      setTimeout(function () {
        $('.js-download-button')
          .removeClass('js-working')
          .text('Download Images');
      }, 1500);
      $('#progressContainer').addClass('hidden');
      $('#progressContainer').find('.progressBar').css('width', 0);
      canSubmit();
    }
  }

  function initMultipleType() {
    // Initial Selector
    downloadsType.addEventListener('change', typeSelectionHandler);

    // Get type to filter by
    let type = getParameterByName('type');

    if (type) {
      // Select correct type option
      document.querySelector(
        '#downloadsType [value="' + type + '"]',
      ).selected = true;

      // Initialize search based on type
      switch (type) {
        case 'PILLOWS':
          initProducts('PILLOWS');
          break;
        case 'THROWS':
          initCollections('THROWS');
          break;
        case 'RUGS':
          initCollections('RUGS');
          break;
        case 'WALL-ART':
          initProducts('WALL-ART');
          break;
        case 'POUFS':
          initProducts('POUFS');
          break;
      }
    }
  }

  function pdpLoadBtns() {
    $('img.is-image')
      .on('load', function () {
        if (
          $(this).parent().next('.js-s3-photo-data').data('s3ImageName') !=
            '' &&
          $(this).parent().next('.js-s3-photo-data').hasClass('hidden')
        ) {
          $(this).parent().next('.js-s3-photo-data').removeClass('hidden');
        }
      })
      .each(function () {
        if (this.complete) $(this).trigger('load');
      });
  }

  function pdpGetPhotoName() {
    if (!pagePDP) return;
    let photoNames = [];
    $('.product-detail__images .js-s3-photo-data').each(function () {
      let imgSrc = $(this).prev('picture').find('img').data('img-full');
      let photoName = getPhotoName(imgSrc);
      photoNames.push(photoName);
    });
    if (photoNames.toString().length > 0) checkPhotosExist(photoNames, bucket);
  }

  function checkPhotosExist(photoNames, bucket) {
    window.MUAPP.scripts.images.checkAWSForImages(
      photoNames,
      bucket,
      (result) => {
        photoNames = result.images;
        return pdpBtnData(photoNames);
      },
    );
  }

  function pdpBtnData(photoNames) {
    $('.product-detail__images .js-s3-photo-data').each(function (i) {
      $(this).attr('data-s3-image-name', photoNames[i]);
      if (photoNames[i] != '') {
        $('#hiddenS3Information').append(
          `<span class="js-s3-photo-data" data-s3-image-name="${photoNames[i]}"></span>`,
        );
      }
    });
    if ($('#hiddenS3Information').children().length > 0) {
      return pdpLoadBtns();
    }
  }

  function initSingleType(type = null) {
    initCollections(type);
  }

  function init() {
    if (
      $('.js-photo-download').length <= 0 &&
      $('.js-hangtag-download').length <= 0 &&
      !pagePDP
    )
      return;
    pdpGetPhotoName();
    // Photodownload init (Rugs, Pillows, Throws)
    if ($('.js-photo-download').length > 0) initMultipleType();

    // Photodownload init (Rugs, Pillows, Throws)
    if ($('.js-hangtag-download').length > 0) initSingleType('RUGS');

    // Bind click handlers
    $('#checkall').on('click', toggleAllHandler);
    $('.js-download-results').on('click', '.card-block__item', selectedHandler);
    $('.js-download-button').on('click', submitHandler);
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/photo-downloads.js